"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/ImportPatients/usePatientsTabImport.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _noticeBar = require('web/services/context/noticeBar');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _download = require('web/screens/Broadcast/Wizard/Recipients/download');
var _ImportButton = require('./ImportButton'); var _ImportButton2 = _interopRequireDefault(_ImportButton);
var _ImportPatientsDialog = require('./ImportPatientsDialog'); var _ImportPatientsDialog2 = _interopRequireDefault(_ImportPatientsDialog);
var _ImportStatusBar = require('./ImportStatusBar'); var _ImportStatusBar2 = _interopRequireDefault(_ImportStatusBar);
var _useDirectoryImport = require('./useDirectoryImport');

const errorReason = (e, fallback) => _optionalChain([(e ), 'optionalAccess', _ => _.Error]) || fallback

/* D-97, D-98: the Patients tab's import, for admins: the button left of the +,
 * the Import patients dialog, and the import's progress bar, then its result
 * line, in the archive bar's place. Members get none of them (D-101). */
 const usePatientsTabImport = ({ orgKey, isAdmin, tags, onTagsChanged, onFinished, onShowTag }









) => {
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [isOpen, setOpen] = _react.useState.call(void 0, false)
  const patientImport = _useDirectoryImport.useDirectoryImport.call(void 0, { orgKey, isEnabled: isAdmin, onFinished })
  const { started, status } = patientImport

  const onStarted = _react.useCallback.call(void 0, (next) => {
    started(next)
    // New tags are listed at once.
    onTagsChanged()
  }, [started, onTagsChanged])

  const onDownload = _react.useCallback.call(void 0, () => {
    if (!status) return
    _actions2.default.downloadDirectoryImportErrors({ OrgKey: orgKey, TaskKey: status.TaskKey })
      .then(({ FileName, Csv }) => _download.downloadText.call(void 0, FileName, Csv, 'text/csv'))
      .catch(e => showWarningBar(errorReason(e, 'Couldn\'t download the rows.')))
  }, [status, orgKey, showWarningBar])

  const onShowPatients = _react.useCallback.call(void 0, () => {
    // The tag the import created, as only its patients have it (J-9); else its first.
    const tag = _nullishCoalesce(_optionalChain([status, 'optionalAccess', _2 => _2.Tags, 'access', _3 => _3.find, 'call', _4 => _4(t => t.Created)]), () => ( _optionalChain([status, 'optionalAccess', _5 => _5.Tags, 'access', _6 => _6[0]])))
    if (tag) onShowTag(tag.TagKey)
  }, [status, onShowTag])

  const onImportAgain = _react.useCallback.call(void 0, () => {
    if (!status) return
    _actions2.default.startDirectoryImport({
      OrgKey: orgKey,
      FileKey: status.FileKey,
      Mapping: status.Mapping,
      Removed: _nullishCoalesce(status.Removed, () => ( [])),
      TagKeys: status.Tags.map(t => t.TagKey),
      NewTagNames: [],
      Existing: status.Existing,
    })
      .then(onStarted)
      .catch(e => showWarningBar(errorReason(e, 'Couldn\'t start the import again.')))
  }, [status, orgKey, onStarted, showWarningBar])

  return {
    button: isAdmin ? _react2.default.createElement(_ImportButton2.default, { isDialogOpen: isOpen, onClick: () => setOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}} ) : null,
    bar: status && (
      _react2.default.createElement(_ImportStatusBar2.default, {
        status: status,
        onDownload: onDownload,
        onShowPatients: onShowPatients,
        onImportAgain: onImportAgain,
        onDismiss: patientImport.dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
      )
    ),
    dialog: isAdmin && (
      _react2.default.createElement(_ImportPatientsDialog2.default, {
        isOpen: isOpen,
        orgKey: orgKey,
        tags: tags,
        onClose: () => setOpen(false),
        onStarted: onStarted, __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
      )
    ),
  }
}; exports.usePatientsTabImport = usePatientsTabImport
